import React, { useEffect, useState } from 'react';
import { Box, Button, TextField, IconButton, Modal, Typography } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';

interface Disposition {
    id?: string;
    statuses: string[];
}

interface CreateRoleFormProps {
    open: boolean;
    editMode: boolean;
    initialData?: Disposition | null;
    onClose: (data: null | Disposition) => void;
    onDelete?: (id: string) => void;
}
interface Field {
    id: number;
    value: string;
    label?:string;
}


const CreateEditDispositionModal: React.FC<CreateRoleFormProps> = ({
    open,
    editMode,
    initialData,
    onClose,
    onDelete
}) => {
    const [fields, setFields] = useState<Field[]>([{ id: Date.now(), value: '' }]);
    const handleAddField = () => {
        setFields([...fields, { id: Date.now(), value: '',label:'' }]);
    };

    const handleUpdateField = (id: number, newValue: string) => {
        setFields(prevFields =>
            prevFields.map(field => (field.id === id ? { ...field, value: newValue,label:newValue } : field))
        );
    };

    const handleDeleteField = (id: number) => {
        setFields(prevFields => prevFields.filter(field => field.id !== id));
    };


    return (
        <Modal open={open} onClose={() => onClose(null)}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '8px',
                    p: 3,
                    width: 400,
                    maxHeight: '90vh',
                    overflowY: 'auto',
                }}
            >
                <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {editMode ? 'Edit Disposition Status' : 'Create Disposition Status'}
                </Typography>

                {fields.map((field, index) => (
                    <Box key={field.id} sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <TextField
                            label={`Status ${index + 1}`}
                            variant="outlined"
                            fullWidth
                            size='small'
                            value={field.value}
                            onChange={e => handleUpdateField(field.id, e.target.value)}
                        />
                        <IconButton
                            color="error"
                            onClick={() => handleDeleteField(field.id)}
                            sx={{ ml: 1 }}
                            aria-label="delete"
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                ))}

                <Button variant="contained" size='small' onClick={handleAddField}>
                    Add Field
                </Button>


                <Box mt={3} display="flex" justifyContent="space-between">
                    <Button variant="outlined" onClick={() => onClose(null)} size="small">
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                    >
                        {editMode ? 'Update' : 'Create'}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default CreateEditDispositionModal;
{/* <CreateEditDispositionModal
open={true}
mode={false}
onClose={(data) => {
  if (data) {
    console.log("Created new disposition:", data);
  }
}}
/>
 */}
